import '@babel/polyfill';

import Vue from 'vue';

import VueLogger from 'vuejs-logger';

import axios from 'axios';
import VueAxios from 'vue-axios';

import vuetify from './plugins/vuetify';

import { localize, extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import en from 'vee-validate/dist/locale/en.json';
import fr from 'vee-validate/dist/locale/fr.json';
import ValidatorsLoader from '@/validators';

import moment from 'moment';

import App from './App.vue';
import router from './router';
import store from './store';

import DefaultLayout from '@/layouts/Default.vue';
import NoNavLayout from '@/layouts/NoNav.vue';

import { AUTH_LOGOUT } from '@/store/actions/auth';


Vue.use(VueLogger, {
  // optional : defaults to true if not specified
  isEnabled: process.env.NODE_ENV !== 'production',
  // required ['debug', 'info', 'warn', 'error', 'fatal']
  logLevel: 'debug',
  // optional : defaults to false if not specified
  stringifyArguments: false,
  // optional : defaults to false if not specified
  showLogLevel: false,
  // optional : defaults to false if not specified
  showMethodName: false,
  // optional : defaults to '|' if not specified
  separator: '|',
  // optional : defaults to false if not specified
  showConsoleColors: false
});

Vue.use(VueAxios, axios);
axios.defaults.baseURL = '/api/v1';
axios.interceptors.response.use(undefined, err => {
  if (err.response.status === 401) {
    // Logout the user
    store.dispatch(AUTH_LOGOUT).then(() => {
      // Redirect to login page
      router.push({ name: 'login' });
    });
  }

  return Promise.reject(err);
});

// Vee-Validate
ValidatorsLoader(extend);
localize({
  en,
  fr
});
localize('fr');

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

// Layout components
Vue.component('default-layout', DefaultLayout);
Vue.component('no-nav-layout', NoNavLayout);

// Moment
moment.locale('fr');

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
